import React, { useRef } from "react";
import { Typography, Box, Button, Grid, Chip, Divider } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Signature from "../../../../common/signature/signature";

// Define validation schema
const validationSchema = Yup.object().shape({
  agree: Yup.boolean().oneOf([true], "You must agree to the terms to proceed."),
});

const RoomSearchAgreeAdmission = () => {
  const signatureRef = useRef(null);

  // Initial form values
  const initialValues = {
    agree: true,
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        const signatureData = signatureRef.current.getSignatureData();
        if (!signatureData) {
          alert("Please provide a signature");
          return;
        }

        const formData = { ...values, signature: signatureData };

        console.log("Form data submitted:", formData);
      }}
    >
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit} className='admission-form'>
          {/* Header Section */}
          <Box mb={2}>
            <Chip label='Admission' />
            <Typography sx={{ fontSize: "24px", fontWeight: "bold", color: "black" }} align='left' mt={1}>
              CYP Room search agreement
            </Typography>
          </Box>
          <Divider className='divider' />
          <Typography sx={{ fontSize: "14px", color: "black" }} mt={5}>
            I am signing below to confirm the staff team have explained to me what the reasons are that my room may be
            searched. I understand I can be present when this may happen.
          </Typography>
          <Typography sx={{ fontSize: "14px", color: "black" }} mt={2}>
            I understand if my room is searched, and any items are removed I will be informed and staff are doing this
            only to keep me safe.
          </Typography>
          {/* Signature Section */}
          <Box className='signature-box'>
            <Signature ref={signatureRef} />
            <Typography align='right'>
              <Grid container>
                <Grid item>
                  <Typography sx={{ fontSize: "14px", color: "#FFB700" }}>Venorox</Typography>
                </Grid>
                <Grid item>
                  {" "}
                  <Typography sx={{ fontSize: "14px" }}>/ Signature</Typography>
                </Grid>
              </Grid>
              <Grid className='clear-signature-button'>
                <Button variant='outlined' onClick={() => signatureRef.current?.clearSignature()}>
                  Clear
                </Button>
              </Grid>
            </Typography>
          </Box>
          {/* Submit Button */}
          <Grid item xs={12} mr={1}>
            <div className='submit-button-container'>
              <Button type='submit' variant='contained' color='primary' className='submit-button'>
                Submit
              </Button>
            </div>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default RoomSearchAgreeAdmission;
